import { render, staticRenderFns } from "./bankPay.vue?vue&type=template&id=4160f56f&scoped=true&"
var script = {}
import style0 from "./bankPay.vue?vue&type=style&index=0&id=4160f56f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160f56f",
  null
  
)

export default component.exports